import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ServeFormComponent } from './serve-form.component';

import { PrescriptionTransactionService, PrescriptionItemService } from '../../../../services';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ServeFormComponent
  ],
  providers: [
    PrescriptionTransactionService,
    PrescriptionItemService
  ],
  exports: [
    ServeFormComponent
  ],
})
export class ServeFormModule { }
